export default {
	ETaxProductMtax: 'Sản phẩm thuế điện tử MISA mTax',
	Currency: 'Đơn vị tính',
	VND: 'VNĐ',
	SelectYearUsed: 'Chọn gói sử dụng',
	SelectNumberEsignBuy: 'Chọn số lượng Chữ ký số cần mua',
	BuyAttachEsign: 'Mua kèm chữ ký số MISA eSign - Doanh nghiệp',
	SelectYearCertificate: 'Chọn số năm sử dụng Chữ ký số',
	USBHasCertificate: 'USB Token ký số',
	BuyMoreOtherUSB: 'Mua thêm USB Token dự phòng',
	USBReplaceIfBroken:
		'USB token dùng để thay thế ngay khi USB ký số gặp vấn đề',
	Certificate: 'Chữ ký số',
	UsedForMisaUser: 'Phần dành riêng cho nhân viên MISA',
	InputUserCode: 'Nhập mã nhân viên',
	Order: 'Đơn hàng',
	DoOrder: 'Đặt hàng',
	MISAmTax: 'MISA mTax',
	MISAESign: 'MISA eSign',
	EsignCertificate: 'Chữ ký số',
	USBTokenOther: 'USB Token dự phòng',
	USBToken: 'USB Token',
	TotalMoney: 'Tổng tiền',
	Discount: 'Giảm giá',
	IntoMoney: 'Tổng tiền thanh toán',
	HasVAT: '(Giá đã bao gồm 10% VAT)',
	ResourcesAfterBuy: 'TÀI NGUYÊN SAU KHI MUA',
	Account: 'tài khoản',
	YearUsed: 'năm sử dụng',
	Year: 'năm',
	Used: 'sử dụng',
	Next: 'Tiếp theo',
	USBOther: 'USB dự phòng',
	CompanyInfo: 'Thông tin dịch vụ MISA mTax',
	TaxCode: 'Mã số thuế/CCCD',
	CompanyName: 'Tên công ty, tổ chức',
	Address: 'Địa chỉ',
	Province: 'Tỉnh/Thành phố',
	District: 'Quận/Huyện',
	Ward: 'Phường/Xã',
	AddressPlaceHolder: 'Địa chỉ, Phường/Xã, Quận/Huyện, Tỉnh/Thành phố',
	UserInfo: 'Thông tin người dùng MISA mTax',
	PhoneNumber: 'Số điện thoại',
	Email: 'Email',
	FirstName: 'Họ đệm',
	LastName: 'Tên',
	Role: 'Chức danh',
	MasterEsignInfo: 'Thông tin chủ sở hữu MISA eSign',
	PhoneLoginMisaMtax: 'SĐT đăng nhập MISA mTax',
	EmailLoginMisaMtax: 'Email đăng nhập MISA mTax',
	PhoneLoginMisaEsign: 'SĐT đăng nhập MISA eSign',
	EmailLoginMisaEsign: 'Email đăng nhập MISA eSign',
	AddressUSBToken: 'Địa chỉ nhận USB Token',
	SameUserInfo: 'Giống thông tin người dùng',
	ExportInvoice: 'Thông tin xuất hóa đơn',
	SameCompanyInfo: 'Giống thông tin dịch vụ',
	UnitInfo: 'THÔNG TIN ĐƠN VỊ',
	BuyerInfo: 'THÔNG TIN NGƯỜI MUA',
	FullName: 'Họ và tên',
	ReceiveInvoiceInfo: 'THÔNG TIN NGƯỜI NHẬN HÓA ĐƠN',
	MISAExportInfoAfterGetMoney:
		'MISA sẽ xuất hóa đơn điện tử theo thông tin khách hàng cung cấp ngay khi nhận được tiền thanh toán',
	AcceptData:
		'Tôi xác nhận và chịu trách nhiệm với các thông tin trên là đúng',
	ContactPayment: 'LIÊN HỆ MUA HÀNG',
	CompanyAndInvoiceInfo: 'Thông tin cấp dịch vụ & hóa đơn',
	Pay: 'Thanh toán',
	Saving: 'Tiết kiệm',
	SelectPaymentMethod: 'Chọn hình thức thanh toán',
	ATMCard: 'Thẻ ATM',
	VISACard: 'Thẻ tín dụng, VISA',
	EWallet: 'Ví điện tử',
	Transfer: 'Chuyển khoản',
	SelectBankPayment: 'Chọn ngân hàng thanh toán',
	NeedRegisterInternetBanking:
		'Quý khách cần đăng ký Internet banking hoặc dịch vụ thanh toán trực tuyến tại ngân hàng đã chọn trước khi thanh toán',
	InputVerifyCode: 'Nhập mã xác thực',
	IrrespectiveCase: 'Không phân biệt chữ in hoa, in thường',
	TotalAmount: 'Tổng tiền thanh toán',
	ViewTutorial: 'Xem hướng dẫn sử dụng',
	Back: 'Quay lại',
	MisaHNBranchName: 'MISA HÀ NỘI',
	MisaHNBranchPhone: '086 620 8677 - 088 623 8677',
	MisaHNBranchPhone2: '089 955 8677 (Máy lẻ 9)',
	MisaHNBranchEmail: 'ers@han.misa.com.vn',
	MisaHCMBranchName: 'MISA TP HCM',
	MisaHCMBranchPhone: '0285 431 8318 (Máy lẻ 0)',
	MisaHCMBranchEmail: 'ers@hcm.misa.com.vn',
	MisaDNBranchName: 'MISA ĐÀ NẴNG',
	MisaDNBranchPhone: '0236 366 7555 (Máy lẻ 148)',
	MisaDNBranchEmail: 'ers@dng.misa.com.vn',
	MisaBMTBranchName: 'MISA BUÔN MÊ THUỘT',
	MisaBMTBranchPhone: '0262 381 7400 (Máy lẻ 207)',
	MisaBMTBranchEmail: 'ers@bmt.misa.com.vn',
	MisaCTBranchName: 'MISA CẦN THƠ',
	MisaCTBranchPhone: '0292 376 6468 (Máy lẻ 146)',
	MisaCTBranchEmail: 'ers@cth.misa.com.vn',
	MisaAdress:
		'Tầng 9, tòa nhà Technosoft, phố Duy Tân, phường Dịch Vọng Hậu, Q. Cầu Giấy, Tp. Hà Nội',
	CNDKKDInfo:
		'Giấy CNĐKKD: 0101243150 - Ngày cấp: 22/4/2002, được sửa đổi lần thứ 14 ngày 23/7/2018',
	organApply:
		'Cơ quan cấp: Phòng Đăng ký kinh doanh - Sở Kế hoạch và Đầu tư TP.Hà Nội',
	YouHasDiscount: 'Quý khách được giảm ',
	YouHasDiscountMonth: 'Quý khách được tặng ',
	SelectTransferMethod: 'Chọn hình thức chuyển khoản',
	TransferFromTransaction: 'Chuyển khoản tại quầy giao dịch của ngân hàng',
	TransferByInternetBanking: 'Chuyển khoản qua Internet Banking',
	CaptchaCode: 'Mã xác thực',
	OrderComplete: 'Đặt hàng thành công!',
	InfoOrderHasSendEmail: 'Thông tin chi tiết đơn hàng đã được gửi đến email',
	OfUser: 'của quý khách',
	HelpInfoEsign: 'Hướng dẫn hoàn thiện hồ sơ eSign',
	TranferNote:
		'Quý khách cần thanh toán trong vòng 24h để MISA cấp tài nguyên cho quý khách và bắt đầu sử dụng dịch vụ. Xin vui lòng nhập thông tin chuyển khoản theo nội dung dưới đây:',
	BeneficiaryUnit: 'Đơn vị thụ hưởng',
	AccountName: 'Tên tài khoản',
	NumberAccount: 'Số tài khoản',
	OpenFrom: 'Mở tại',
	ContentTranfer: 'Nội dung chuyển tiền',
	Copy: 'Sao chép',
	TranferWarning:
		'<i>Lưu ý: Quý khách cần ghi đúng<strong>&nbsp;SỐ ĐƠN HÀNG, MÃ SỐ THUẾ&nbsp;</strong>của đơn vị và<strong>&nbsp;SỐ ĐIỆN THOẠI&nbsp;</strong>của người chuyển tiền trên nội dung chuyển khoản, để MISA xác định đơn hàng đã được thanh toán và cấp dịch vụ, tránh CẤP NHẦM hoặc KHÔNG CẤP dịch vụ cho quý khách.</i><div><i>Xin vui lòng sao chép hoặc chụp lại nội dung thanh toán gọi ý màu đỏ ở trên để tránh bị quên.</i></div>',
	Started: 'Bắt đầu sử dụng',
	FailureOrder: 'Đặt hàng không thành công!',
	PaymentOther: 'Bạn muốn thực hiện giao dịch khác?',
	Cancel: 'Hủy bỏ',
	OK: 'Đồng ý',
	CopySuccess: 'Sao chép thành công!',
	BankFrom: 'Hội sở ngân hàng TMCP Á Châu',
	ErrorTaxCodeExist: (TaxCode, ContactEmail, ContactMobile, link) =>
		`Mã số thuế <strong>${TaxCode}</strong> đã được đăng ký sử dụng bởi email <strong>${ContactEmail}</strong> và số điện thoại <strong>${ContactMobile}</strong>. Vui lòng sử dụng tài khoản này để đăng nhập <strong><a href="${link}" target="_blank">${link}</a></strong> và sử dụng dịch vụ.`,
	Month: 'tháng',
	Product: 'sản phẩm',
	Aplly: 'Áp dụng',
	PromotionCode: 'Mã giảm giá',
	AddressUSBTips:
		'Sau khi quý khách hoàn thiện hồ sơ cấp chứng thư số MISA eSign, MISA sẽ chuyển phát USB Token về Địa chỉ nhận USB Token mà quý khách đã khai báo. Vui lòng nhập đúng.',
	CaptchaFalse: 'Mã xác thực không đúng',
	MISACompanyName: 'CÔNG TY CỔ PHẦN MISA',
	Close: 'Đóng',
	ProcessingPayment:
		'Đang thanh toán, vui lòng không tắt trình duyệt và chờ trong ít phút'
};
